import { notifyPaymentButtonClicked, notifyPaymentIntent, notifyPaymentMethodSelected } from './notifier';
import { getEventDataForSdkEvents } from './eventDataBuilder';
import type { ICheckoutContext } from '@/types/context';
import type { PaymentMethodEnum } from '@/types/common';
import { trackPayButtonClicked, trackPaymentChoose } from './checkoutMixpanelTracking';
import { getPaymentMethodDisplayName, resolveAttributedPaymentMethod } from './paymentMethodResolvers';
import type { EventData } from '@/services/iframeMessenger';

export const trackAndNotifyPaymentClick = (
  context: ICheckoutContext,
  additionalProperties?: Partial<EventData>
): void => {
  trackPayButtonClicked(context, additionalProperties);
  notifyPaymentButtonClicked(getEventDataForSdkEvents(context, additionalProperties));
};

export const notifyPaymentIntentClick = (
  context: ICheckoutContext,
  additionalProperties?: Partial<EventData>
): void => {
  notifyPaymentIntent(getEventDataForSdkEvents(context, additionalProperties));
};

export const trackAndNotifyPaymentMethodSelected = (context: ICheckoutContext, nextMethod: PaymentMethodEnum): void => {
  const previousMethod = resolveAttributedPaymentMethod(context.paymentMethodSelected, context.otherMethodSelected);
  if (nextMethod === previousMethod) return;

  trackPaymentChoose(context, nextMethod, previousMethod);
  notifyPaymentMethodSelected(
    getEventDataForSdkEvents(context, {
      paymentMethodName: nextMethod,
      previousPaymentMethodName: getPaymentMethodDisplayName(previousMethod, context.paymentMethodsSettings ?? []),
    })
  );
};
